import React from 'react';
import AvatarEditor from 'react-avatar-editor';
import Dropzone from 'react-dropzone';

import themeConfig from '../../theme/theme-config';
import FlexColumn from '../FlexColumn';
import FlexRow from '../FlexRow';
import SvgIcon from '../SvgIcon';
import initialImage from './Image.png';
import icMinus from './ic-minus.svg';
import icPlus from './ic-plus.svg';

type Props = {
    src?: string;
    setImageEditorRef?: (ref) => void;
    width?: number;
    height?: number;
    onDrop?: (img: File) => void;
};

type State = {
    image: null | string;
    scale: number;
};

class ImageEditor extends React.Component<Props, State> {
    state = {
        image: this.props.src || initialImage,
        scale: 1,
    };

    handleDrop = (dropped) => {
        const { onDrop } = this.props;
        this.setState({ image: dropped[0] });
        onDrop && onDrop(dropped[0]);
    };

    render() {
        const { width = '100%', height = '100%', setImageEditorRef } = this.props;
        const { image, scale } = this.state;

        return (
            <Dropzone onDrop={this.handleDrop} noClick noKeyboard>
                {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} style={{ width, height }}>
                        <FlexColumn itemsSpacing={20}>
                            <AvatarEditor
                                ref={setImageEditorRef}
                                width={518}
                                height={259}
                                image={image}
                                border={[0, 0]}
                                color={[0, 0, 0, 0.6]}
                                scale={scale}
                                style={{ borderRadius: themeConfig.borderRadius.base }}
                            />
                            <input {...getInputProps()} />
                            <FlexRow align="center" itemsSpacing={16}>
                                <SvgIcon src={icMinus} color={(theme) => theme.color.gray40} />
                                <input
                                    type="range"
                                    min="0.5"
                                    max="2"
                                    step="0.01"
                                    value={scale}
                                    onChange={(ev) =>
                                        this.setState({ scale: Number(ev.target.value) })
                                    }
                                />
                                <SvgIcon src={icPlus} color={(theme) => theme.color.gray40} />
                            </FlexRow>
                        </FlexColumn>
                    </div>
                )}
            </Dropzone>
        );
    }
}

export default ImageEditor;
